import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant.js';

export const FJSliceRecord = createSlice({
    name: 'record',
    initialState: {
        recordStatus: FJConstant.DEFAULT,
        recorderFrequency: 0,
        recorderDeviceList: [],
        recorderDeviceId: '',
        recorderDuration: 0,
        isShowRecorderDelay: false,
        audioUrl: '',
        audioName: '',
    },
    reducers: {
        setSliceRecordStatus: (state, action) => {
            state.recordStatus = action.payload;
        },
        setSliceRecorderFrequency: (state, action) => {
            state.recorderFrequency = action.payload;
        },
        setSliceRecorderDeviceList: (state, action) => {
            state.recorderDeviceList = action.payload;
        },
        setSliceRecorderDeviceId: (state, action) => {
            state.recorderDeviceId = action.payload;
        },
        setSliceRecorderDuration: (state, action) => {
            state.recorderDuration = action.payload;
        },
        setSliceIsShowRecorderDelay: (state, action) => {
            state.isShowRecorderDelay = action.payload;
        },
        setSliceAudioUrl: (state, action) => {
            state.audioUrl = action.payload;
        },
        setSliceAudioName: (state, action) => {
            state.audioName = action.payload;
        },
    },
});

export const {
    setSliceRecordStatus,
    setSliceRecorderFrequency,
    setSliceRecorderDeviceList,
    setSliceRecorderDeviceId,
    setSliceRecorderDuration,
    setSliceIsShowRecorderDelay,
    setSliceAudioUrl,
    setSliceAudioName,
} = FJSliceRecord.actions;

export default FJSliceRecord.reducer;
